import {
    FETCH_AUDIT_EVENTS,
    FETCH_AUDIT_EVENTS_FAIL,
    FETCH_AUDIT_EVENTS_SUCCESS,
    FETCH_AUDIT_USERS,
    FETCH_AUDIT_USERS_FAIL,
    FETCH_AUDIT_USERS_SUCCESS
} from './actionTypes';

/* args: { page, pageSize, sortType, sortOrder, jurisdiction, eventType } */
export const fetchAuditEvents = args => ({
    type: FETCH_AUDIT_EVENTS,
    payload: args || {}
});

export const fetchAuditEventsSuccess = response => ({
    type: FETCH_AUDIT_EVENTS_SUCCESS,
    payload: response
});

export const fetchAuditEventsFail = error => ({
    type: FETCH_AUDIT_EVENTS_FAIL,
    payload: error
});

/* The admins, to say who did it by name. */
export const fetchAuditUsers = () => ({
    type: FETCH_AUDIT_USERS
});

export const fetchAuditUsersSuccess = users => ({
    type: FETCH_AUDIT_USERS_SUCCESS,
    payload: users
});

export const fetchAuditUsersFail = error => ({
    type: FETCH_AUDIT_USERS_FAIL,
    payload: error
});
